import { AnyAction } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "@reduxjs/toolkit";

// Иниициализация редьюсеров производных от базового
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { mutualFundApi } from "../api/mutualFundApi";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { profileApi } from "../api/profileApi";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { authApi } from "../api/authApi";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { documentsApi } from "../api/documentsApi";

import { surveyApi } from "../api/surveyApi";
import { strategyApi } from "../api/strategyApi";
import { settingsApi } from "../api/settingsApi";
import { briefcaseApi } from "../api/briefcaseApi";
import { manageFundsApi } from "../api/manageFundsApi";

import auth, { authReducerPersistConfig } from "../slices/authSlice";
import profile, { profileReducerPersistConfig } from "../slices/profileSlice";
import briefcase, { briefcaseReducerPersistConfig } from "../slices/briefcaseSlice";
import application, { applicationReducerPersistConfig } from "../slices/applicationSlice";
import { operationsJournalApi } from "../api/operationsJournalApi";
import { replenishSlice } from "../slices/replenishSlice";
import { requisiteApi } from "../api/requisiteApi";
import { qrCodeApi } from "../api/qrCodeApi";
import { notificationSlice } from "../slices/notificationSlice";
import { blogApi } from "../api/blogApi";
import { captchaApi } from "../api/captchaApi";
import { captchaSlice } from "../slices/captchaSlice";
import { surveySlice } from "../slices/surveySlice";
import apiHostsReducer, {
  apiHostsReducerPersistConfig,
  ApiHostsState,
} from "../slices/apiHostsSlice";
import { baseApi } from "../api/baseApi";

export const rootReducer = combineReducers({
  apiHosts: persistReducer<ApiHostsState, AnyAction>(
    {
      ...apiHostsReducerPersistConfig,
      key: "apiHosts",
      storage,
    },
    apiHostsReducer,
  ),
  application: persistReducer<Store.AppReducerState, AnyAction>(
    {
      ...applicationReducerPersistConfig,
      key: "application",
      storage,
    },
    application,
  ),
  profile: persistReducer<Store.ProfileReducerState, AnyAction>(
    {
      ...profileReducerPersistConfig,
      key: "profile",
      storage,
    },
    profile,
  ),
  auth: persistReducer<Store.AuthReducerState, AnyAction>(
    {
      ...authReducerPersistConfig,
      key: "auth",
      storage,
    },
    auth,
  ),
  briefcase: persistReducer<Store.BriefcaseReducerState, AnyAction>(
    {
      ...briefcaseReducerPersistConfig,
      key: "briefcase",
      storage,
    },
    briefcase,
  ),
  [surveySlice.name]: surveySlice.reducer,
  [replenishSlice.name]: replenishSlice.reducer,
  [captchaSlice.name]: captchaSlice.reducer,
  [notificationSlice.name]: notificationSlice.reducer,
  // Api
  [baseApi.reducerPath]: baseApi.reducer,
  [captchaApi.reducerPath]: captchaApi.reducer,
  [surveyApi.reducerPath]: surveyApi.reducer,
  [requisiteApi.reducerPath]: requisiteApi.reducer,
  [strategyApi.reducerPath]: strategyApi.reducer,
  [qrCodeApi.reducerPath]: qrCodeApi.reducer,
  [settingsApi.reducerPath]: settingsApi.reducer,
  [briefcaseApi.reducerPath]: briefcaseApi.reducer,
  [blogApi.reducerPath]: blogApi.reducer,
  [manageFundsApi.reducerPath]: manageFundsApi.reducer,
  [operationsJournalApi.reducerPath]: operationsJournalApi.reducer,
});
